export const dashboardImages = {
    HELLO_ICON: require("./hello-icon.png"),
};

